import { ToolBarButton } from 'components/ToolBarButton'
import usePane from 'hooks/usePane'
import { File } from 'react-feather'
import type { SideToolBarProps } from 'types'

export const NotesButton = ({ showNotesBadge }: Partial<SideToolBarProps>) => {
  const { paneVisible, togglePane } = usePane('Note')
  const showBadge = showNotesBadge ? 'info' : null

  return (
    <ToolBarButton
      disabled={paneVisible}
      label="NOTES"
      icon={File}
      tooltipText="NOTES"
      clickCallback={togglePane}
      badgeStatus={showBadge}
    />
  )
}
